import { createRouter, createWebHistory, RouteRecordRaw, createWebHashHistory } from 'vue-router'
import Home from "@/views/home/home.vue"
import Login from "@/views/login/login.vue"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    children: [
      {
        path: "",
        redirect: "gailan",
      },
      { path: "gailan", name: "gailan", meta: { name: '概览' }, component: () => import("@/views/home/children/gailan.vue") },
      { path: "project", name: "project", meta: { name: '项目' }, component: () => import("@/views/home/children/project.vue") },
      {
        path: "device", name: "device", meta: { name: '设备' }, component: () => import("@/views/home/children/device.vue"),
        children: [
          {
            path: "tuopu", name: "tuopu", meta: { name: '设备-拓扑图' }, component: () => import("@/views/home/children/devChild/tuoputu.vue")
          },
          {
            path: "map", name: "map", meta: { name: '设备-地图' }, component: () => import("@/views/home/children/devChild/mapCmp.vue")
          },
          {
            path: "jiaohuanji", name: "jiaohuanji", meta: { name: '设备-交换机' }, component: () => import("@/views/home/children/devChild/jiaohuanji.vue")
          },
          {
            path: "deviceInfo", name: "deviceInfo", meta: { name: '设备-交换机-设备详情' }, component: () => import("@/views/home/children/devChild/deviceInfo.vue")
          },
          {
            path: "portInfo", name: "portInfo", meta: { name: '设备-交换机-设备详情-端口详情' }, component: () => import("@/views/home/children/devChild/portInfo.vue")
          },
          {
            path: "biaozhuPortState", name: "biaozhuPortState", meta: { name: '设备-交换机-设备详情-标注端口状态' }, component: () => import("@/views/home/children/devChild/biaozhuPortState.vue")
          },
          {
            path: "deviceJiankong", name: "deviceJiankong", meta: { name: '设备-交换机-设备监控' }, component: () => import("@/views/home/children/devChild/deviceJiankong.vue")
          },
          {
            path: "devicePeizhi", name: "devicePeizhi", meta: { name: '设备-交换机-设备配置' }, component: () => import("@/views/home/children/devChild/devicePeizhi.vue")
          },
          {
            path: "markPortStatus", name: "markPortStatus", meta: { name: '设备-交换机-标注端口状态' }, component: () => import("@/views/home/children/devChild/markPortStatus.vue")
          },
          {
            path: "markPortConnectDevice", name: "markPortConnectDevice", meta: { name: '设备-交换机-标注端口连接设备' }, component: () => import("@/views/home/children/devChild/markPortConnectDevice.vue")
          },
        ],
      },
      {
        path: "weihu", name: "weihu", meta: { name: '维护' }, component: () => import("@/views/home/children/weihu.vue"),
        children: [
          { path: "warnRecard", name: "warnRecard", meta: { name: '维护-告警记录' }, component: () => import("@/views/home/children/wranChild/warnRecard.vue") },
          { path: "warnConfig", name: "warnConfig", meta: { name: '维护-告警设置' }, component: () => import("@/views/home/children/wranChild/warnConfig.vue") },
        ],
      },
      { path: "search", name: "search", meta: { name: '搜索' }, component: () => import("@/views/home/children/search.vue") },
      {
        path: "my", name: "my", meta: { name: '我的' }, component: () => import("@/views/home/children/my.vue"),
        children: [
          { path: "base", name: "base", meta: { name: '基本设置' }, component: () => import("@/views/home/children/myChild/base.vue") },
          { path: "anquanConfig", name: "anquanConfig", meta: { name: '安全设置' }, component: () => import("@/views/home/children/myChild/anquanConfig.vue") },
        ],
      },
      { path: "notice", name: "notice", meta: { name: '消息' }, component: () => import("@/views/home/children/notice/notice.vue") },
      { path: "noticeDetail", name: "noticeDetail", meta: { name: '消息' }, component: () => import("@/views/home/children/notice/noticeDetail.vue") },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/wangjiPwd',
    name: 'wangjiPwd',
    component: () => import('@/views/login/wangjiPwd.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/login/register.vue'),
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test.vue'),
  },
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

const whileList = ["/login", "/wangjiPwd", "/register"]

router.beforeEach((to, from, next) => {
  if (localStorage.getItem("user-token") || whileList.some(url => url == to.path)) {
    next()
  } else {
    next("/login")
  }
})


export default router
